import { render, staticRenderFns } from "./ConfirmInvitation.vue?vue&type=template&id=3d4e2cdb&scoped=true&"
import script from "./ConfirmInvitation.vue?vue&type=script&lang=js&"
export * from "./ConfirmInvitation.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmInvitation.vue?vue&type=style&index=0&id=3d4e2cdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4e2cdb",
  null
  
)

export default component.exports